// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand colors */
:root {
  --aan-red: #c40000;
  --aan-blue: #1d439a;
  --aan-dark: #0a3c2f;
  --ink: #1d439a;
  --muted: #6b7280;
  --card: #ffffff;
  --bg: #f6f7fb;
}

/* Page base */
.vm-page {
  background: var(--bg);
  min-height: 100vh;
}

/* HERO */
.vm-hero {
  width: 100%;
  padding: 56px 16px 34px;
  background: linear-gradient(
    180deg,
    rgba(29, 67, 154, 0.08) 0%,
    rgba(196, 0, 0, 0.06) 40%,
    rgba(246, 247, 251, 1) 100%
  );
}

.vm-hero-inner {
  max-width: 980px;
  margin: 0 auto;
  text-align: center;
}

.vm-kicker {
  margin: 0 0 10px;
  color: var(--muted);
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  font-size: 12px;
}

.vm-hero-title {
  margin: 0;
  font-size: 44px;
  font-weight: 900;
  line-height: 1.1;
}

.vm-title-red {
  color: var(--aan-red);
}

.vm-title-blue {
  color: var(--aan-blue);
}

.vm-title-dark {
  color: #000;
}

.vm-hero-underline {
  width: 130px;
  height: 5px;
  margin: 16px auto 14px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--aan-red), var(--aan-blue));
}

.vm-hero-subtitle {
  margin: 0 auto;
  max-width: 720px;
  color: #334155;
  font-size: 16px;
  line-height: 1.7;
  font-weight: 500;
}

/* CONTENT */
.vm-container {
  padding: 18px 0 60px;
  display: flex;
  justify-content: center;
}

.vm-wrapper {
  width: 92%;
  max-width: 980px;
}

/* Sections */
.vm-section {
  margin-top: 26px;
}

.vm-section-head {
  margin-bottom: 18px;
}

.vm-heading {
  font-size: 26px;
  font-weight: 900;
  color: #1d439a;
  margin: 0 0 6px;
}

.vm-heading-sub {
  margin: 0;
  color: var(--muted);
  font-size: 15px;
  line-height: 1.6;
}

/* Cards */
.vm-card {
  background: var(--card);
  padding: 22px 24px;
  border-radius: 14px;
  margin-bottom: 18px;

  /* brand border */
  border-left: 8px solid var(--aan-blue);

  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.vm-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12);
}

.vm-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.vm-subheading {
  font-size: 18px;
  font-weight: 900;
  margin: 0;
  color: var(--ink);
}

.vm-badge {
  background: rgba(10, 60, 47, 0.08);
  color: var(--aan-dark);
  border: 1px solid rgba(10, 60, 47, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 12px;
  white-space: nowrap;
}

.vm-badge-red {
  background: rgba(196, 0, 0, 0.08);
  color: var(--aan-red);
  border: 1px solid rgba(196, 0, 0, 0.18);
}

.vm-badge-blue {
  background: rgba(29, 67, 154, 0.08);
  color: var(--aan-blue);
  border: 1px solid rgba(29, 67, 154, 0.18);
}

.vm-bold {
  font-weight: 800;
  margin: 6px 0 10px;
  color: #111827;
}

.vm-text {
  margin: 0 0 10px;
  color: #111827;
  line-height: 1.75;
  font-size: 15.5px;
}

/* Lists */
.vm-list {
  margin: 10px 0 12px;
  padding-left: 18px;
}

.vm-list li {
  margin-bottom: 8px;
  color: #111827;
  line-height: 1.6;
  font-size: 15.5px;
}

/* Highlight block inside a card */
.vm-highlight {
  margin-top: 14px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(
    90deg,
    rgba(196, 0, 0, 0.06),
    rgba(29, 67, 154, 0.06)
  );
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.vm-highlight-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 900;
  color: var(--aan-dark);
}

.vm-italic {
  font-style: italic;
  font-weight: 700;
  margin: 0 0 8px;
  color: #0f172a;
}

/* Responsive */
@media (max-width: 768px) {
  .vm-hero-title {
    font-size: 32px;
  }

  .vm-heading {
    font-size: 22px;
  }

  .vm-card {
    padding: 18px 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AAN/VisionMissionAAN.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,uBAAuB;EACvB;;;;;GAKC;AACH;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mEAAmE;AACrE;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,iBAAiB;EACjB,sCAAsC;;EAEtC,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,wCAAwC;EACxC,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB;;;;GAIC;EACD,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Brand colors */\n:root {\n  --aan-red: #c40000;\n  --aan-blue: #1d439a;\n  --aan-dark: #0a3c2f;\n  --ink: #1d439a;\n  --muted: #6b7280;\n  --card: #ffffff;\n  --bg: #f6f7fb;\n}\n\n/* Page base */\n.vm-page {\n  background: var(--bg);\n  min-height: 100vh;\n}\n\n/* HERO */\n.vm-hero {\n  width: 100%;\n  padding: 56px 16px 34px;\n  background: linear-gradient(\n    180deg,\n    rgba(29, 67, 154, 0.08) 0%,\n    rgba(196, 0, 0, 0.06) 40%,\n    rgba(246, 247, 251, 1) 100%\n  );\n}\n\n.vm-hero-inner {\n  max-width: 980px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.vm-kicker {\n  margin: 0 0 10px;\n  color: var(--muted);\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\n.vm-hero-title {\n  margin: 0;\n  font-size: 44px;\n  font-weight: 900;\n  line-height: 1.1;\n}\n\n.vm-title-red {\n  color: var(--aan-red);\n}\n\n.vm-title-blue {\n  color: var(--aan-blue);\n}\n\n.vm-title-dark {\n  color: #000;\n}\n\n.vm-hero-underline {\n  width: 130px;\n  height: 5px;\n  margin: 16px auto 14px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--aan-red), var(--aan-blue));\n}\n\n.vm-hero-subtitle {\n  margin: 0 auto;\n  max-width: 720px;\n  color: #334155;\n  font-size: 16px;\n  line-height: 1.7;\n  font-weight: 500;\n}\n\n/* CONTENT */\n.vm-container {\n  padding: 18px 0 60px;\n  display: flex;\n  justify-content: center;\n}\n\n.vm-wrapper {\n  width: 92%;\n  max-width: 980px;\n}\n\n/* Sections */\n.vm-section {\n  margin-top: 26px;\n}\n\n.vm-section-head {\n  margin-bottom: 18px;\n}\n\n.vm-heading {\n  font-size: 26px;\n  font-weight: 900;\n  color: #1d439a;\n  margin: 0 0 6px;\n}\n\n.vm-heading-sub {\n  margin: 0;\n  color: var(--muted);\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n/* Cards */\n.vm-card {\n  background: var(--card);\n  padding: 22px 24px;\n  border-radius: 14px;\n  margin-bottom: 18px;\n\n  /* brand border */\n  border-left: 8px solid var(--aan-blue);\n\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.vm-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12);\n}\n\n.vm-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.vm-subheading {\n  font-size: 18px;\n  font-weight: 900;\n  margin: 0;\n  color: var(--ink);\n}\n\n.vm-badge {\n  background: rgba(10, 60, 47, 0.08);\n  color: var(--aan-dark);\n  border: 1px solid rgba(10, 60, 47, 0.14);\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-weight: 800;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.vm-badge-red {\n  background: rgba(196, 0, 0, 0.08);\n  color: var(--aan-red);\n  border: 1px solid rgba(196, 0, 0, 0.18);\n}\n\n.vm-badge-blue {\n  background: rgba(29, 67, 154, 0.08);\n  color: var(--aan-blue);\n  border: 1px solid rgba(29, 67, 154, 0.18);\n}\n\n.vm-bold {\n  font-weight: 800;\n  margin: 6px 0 10px;\n  color: #111827;\n}\n\n.vm-text {\n  margin: 0 0 10px;\n  color: #111827;\n  line-height: 1.75;\n  font-size: 15.5px;\n}\n\n/* Lists */\n.vm-list {\n  margin: 10px 0 12px;\n  padding-left: 18px;\n}\n\n.vm-list li {\n  margin-bottom: 8px;\n  color: #111827;\n  line-height: 1.6;\n  font-size: 15.5px;\n}\n\n/* Highlight block inside a card */\n.vm-highlight {\n  margin-top: 14px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: linear-gradient(\n    90deg,\n    rgba(196, 0, 0, 0.06),\n    rgba(29, 67, 154, 0.06)\n  );\n  border: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n.vm-highlight-title {\n  margin: 0 0 8px;\n  font-size: 15px;\n  font-weight: 900;\n  color: var(--aan-dark);\n}\n\n.vm-italic {\n  font-style: italic;\n  font-weight: 700;\n  margin: 0 0 8px;\n  color: #0f172a;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .vm-hero-title {\n    font-size: 32px;\n  }\n\n  .vm-heading {\n    font-size: 22px;\n  }\n\n  .vm-card {\n    padding: 18px 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
